import { Box, Text } from '@rbilabs/universal-components';

import BlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';

import { LoyaltyLoader } from '../loyalty-loader';

export const StyledBlockRenderer = BlockRenderer.withConfig({
  margin: 0,
  fontSize: 'xs',
});

export const StyledLoyaltyLoader = LoyaltyLoader;

export const OffersCooldownContainer = Box.withConfig({
  backgroundColor: primitive.bk.$warningLight,
  paddingY: '$2',
});

export const CooldownMessageContainer = Box.withConfig({
  flexDirection: 'column',
});

export const OffersCooldownTitle = Text.withConfig({
  variant: 'headerFour',
  fontSize: 'xs',
  marginBottom: '$0',
});

export const OffersCooldownMessage = Text.withConfig({
  variant: 'copyTwo',
  fontSize: 'xs',
});
